import React from "react";
import SummaryCard from "./SummaryCard";
import { getComplianceNameById } from "./summaryHelpers";
import { FillExcavationMaterialInput } from "../FillExcavationMaterialForm.types";
import { ComplianceData } from "../SetBacksInspectionForm.types";

type Props = {
    data?: FillExcavationMaterialInput;
    complianceData?: ComplianceData[];
};

const FillExcavationMaterialReadOnly: React.FC<Props> = ({ data, complianceData }) => {
    if (!data) return null;
    return (
        <SummaryCard
            title={
                <>
                    <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    Fill/Excavation Material
                </>
            }
        >
            {/* Media Layer 1 */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.mediaLayer1ComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> Media Layer 1</label>
                </div>
            </div>
            {(data as any)?.mediaLayer1ComplianceId === 3 ? (
                <div className="row mb-3">
                    <label>{data?.mediaLayer1Comment}</label>
                </div>
            ) : null}

            {/* Media Layer 2 */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.mediaLayer2ComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> Media Layer 2</label>
                </div>
            </div>
            {(data as any)?.mediaLayer2ComplianceId === 3 ? (
                <div className="row mb-3">
                    <label>{data?.mediaLayer2Comment}</label>
                </div>
            ) : null}

            {/* Media Layer 2 details */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>Bottom of Media Layer 2 (in.)</label>
                </div>
                <div className="col col-md-4">
                    {data?.mediaLayer2Bottom !== undefined && data?.mediaLayer2Bottom !== null && (
                        <span className="print-value">{` (${data?.mediaLayer2Bottom})`}</span>
                    )}
                </div>
            </div>
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>Media Layer 2 Benchmark</label>
                </div>
                <div className="col col-md-4">
                    {(data as any)?.mediaLayer2Benchmark === 1 && (
                        <span className="print-value">{" (Above)"}</span>
                    )}
                    {(data as any)?.mediaLayer2Benchmark === 2 && (
                        <span className="print-value">{" (Below)"}</span>
                    )}
                </div>
            </div>

            {/* Excavation + Dimensions */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.areaReplacedComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> Excavation</label>
                </div>
            </div>
            {/* Dimensions D/L/W */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>Depth (D in feet)</label>
                    {data?.excavationDepth !== undefined && data?.excavationDepth !== null && (
                        <span className="print-value fw-bold">{` (${data?.excavationDepth} ft)`}</span>
                    )}
                </div>
                <div className="col col-md-4">
                    <label>Length (L in feet)</label>
                    {data?.areaReplacedLength !== undefined && data?.areaReplacedLength !== null && (
                        <span className="print-value fw-bold">{` (${data?.areaReplacedLength} ft)`}</span>
                    )}
                </div>
                <div className="col col-md-4">
                    <label>Width (W in feet)</label>
                    {data?.areaReplacedWidth !== undefined && data?.areaReplacedWidth !== null && (
                        <span className="print-value fw-bold">{` (${data?.areaReplacedWidth} ft)`}</span>
                    )}
                </div>
            </div>
            {(data as any)?.areaReplacedCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.areaReplacedComment}</label>
                </div>
            ) : null}

            {/* Replacement Material */}
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.replacementMaterialComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Replacement Material"}</label>
                </div>
            </div>
            {(data as any)?.replacementMaterialCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.replacementMaterialComment}</label>
                </div>
            ) : null}
        </SummaryCard>
    );
};

export default FillExcavationMaterialReadOnly;



